import { c as _c } from "react/compiler-runtime";
import ControlledSelect from "@components/hookform/Select";
import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface SelectFieldProps<T extends FieldValues> {
  control: Control<T>;
  fieldDefinition: FormFieldDefinition<T>;
}
const SelectField = t0 => {
  const $ = _c(11);
  const {
    control,
    fieldDefinition
  } = t0;
  let t1;
  if ($[0] !== fieldDefinition.options) {
    t1 = fieldDefinition.options || [];
    $[0] = fieldDefinition.options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control || $[3] !== fieldDefinition.defaultValue || $[4] !== fieldDefinition.info || $[5] !== fieldDefinition.label || $[6] !== fieldDefinition.name || $[7] !== fieldDefinition.placeholder || $[8] !== fieldDefinition.rules || $[9] !== t1) {
    t2 = <div className="max-w-[360px]"><ControlledSelect placeholder={fieldDefinition.placeholder} control={control} name={fieldDefinition.name} label={fieldDefinition.label} info={fieldDefinition.info} options={t1} rules={fieldDefinition.rules} defaultValue={fieldDefinition.defaultValue} size="md" /></div>;
    $[2] = control;
    $[3] = fieldDefinition.defaultValue;
    $[4] = fieldDefinition.info;
    $[5] = fieldDefinition.label;
    $[6] = fieldDefinition.name;
    $[7] = fieldDefinition.placeholder;
    $[8] = fieldDefinition.rules;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default SelectField;